import React, { useState } from 'react';
import CreateMultipleQuoteStyle from './style';
import useQueryApi from 'src/hooks/useApiQuery';
import { QuoteItemType } from 'src/types';
import { getListQuoteByClient } from 'src/api/apiGetListQuoteByClient';
import { Button, Checkbox, Flex, Spin } from 'antd';
import NotFound from 'src/components/notFoundData';

interface CreateMultipleQuoteProps {
    quoteItem: QuoteItemType;
    onClose: () => void;
}

const CreateMultipleQuote: React.FC<CreateMultipleQuoteProps> = ({
    quoteItem,
    onClose,
}) => {
    const { id, clientRef, clientName } = quoteItem;

    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    const { data = [], isLoading }: any = useQueryApi(
        ['listQuotesByClient', clientRef, id],
        () => {
            return getListQuoteByClient(
                `?elapsedDays=62&${
                    clientRef ? `clientRef=${clientRef}` : `quoteRef=${id}`
                }`,
            );
        },

        {
            enabled: !!clientRef || (!clientRef && !!id),
        },
    );

    const dataSort = (data: QuoteItemType[]) => {
        const field = 'updatedDate';
        const sortedData = [...data]
            .filter((item) => item.id !== id)
            .sort((a, b) => {
                return (
                    new Date(b[field]).getTime() - new Date(a[field]).getTime()
                );
            });
        return sortedData;
    };

    const handleOnChange = (quoteId: string) => {
        setSelectedIds((prev) => {
            if (prev.includes(quoteId)) {
                return prev.filter((item) => item !== quoteId);
            } else {
                return [...prev, quoteId].slice(-2);
            }
        });
    };

    const handleViewQuote = () => {
        if (selectedIds.length > 0) {
            const selects = `${id},${selectedIds.join(',')}`;
            window.open(
                `/quoteDetail/introduction?id=${id}&multipleQuotes=${selects}`,
                '_blank',
            );
            onClose();
        }
    };

    const renderContent = () => (
        <>
            <div className="sub-title">
                Related quotes associated with this customer
            </div>
            {isLoading ? (
                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <Spin />
                </div>
            ) : (
                <div className="wrap-quote">
                    {dataSort(data).length > 0 ? (
                        dataSort(data).map((item) => (
                            <Flex key={item.id} gap={24} align="flex-start">
                                <Checkbox
                                    onChange={() => handleOnChange(item.id)}
                                    checked={selectedIds.includes(item.id)}
                                >
                                    {item.id}
                                </Checkbox>
                                <div>{item.quoteTitle}</div>
                            </Flex>
                        ))
                    ) : (
                        <NotFound
                            content={`Hmm... Sorry we couldn’t find any matches for ${
                                clientName}`}
                        />
                    )}
                </div>
            )}
            <Flex align="center" justify="space-between" className="btn-group">
                <div>{`Select ${selectedIds.length + 1}/3`}</div>
                <Flex gap={16}>
                    <Button
                        type="primary"
                        className="btnEdit"
                        onClick={onClose}
                        ghost
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        className="btnSend"
                        onClick={handleViewQuote}
                        disabled={selectedIds.length === 0}
                    >
                        View quote
                    </Button>
                </Flex>
            </Flex>
        </>
    );

    return (
        <CreateMultipleQuoteStyle>{renderContent()}</CreateMultipleQuoteStyle>
    );
};

export default CreateMultipleQuote;
